import { isNil } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './PrintConfirm.scss';
import { moduleActions } from '../../../redux/modules';
import Button from '../../Shared/Button/Button';
import { getSavedPrintInfo } from '../../../redux/modules/printConfirm/printConfirm.selectors';

export class PrintConfirm extends Component {
  constructor(props) {
    super(props);
    this.printFile = this.printFile.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      printConfirm: { isLoaded: prevIsLoaded },
    } = prevProps;
    const {
      printConfirm: { data, isLoaded, hasFailed },
    } = this.props;
    if (
      prevIsLoaded !== isLoaded &&
      isLoaded &&
      !hasFailed &&
      !isNil(data.base64String)
    ) {
      this.printFile(data.base64String);
    }
  }

  printFile(data) {
    const byteCharacters = atob(data);
    const byteNumbers = Array.from(byteCharacters).fill(0);
    let i;
    for (i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const file = new Blob([byteArray], { type: 'application/pdf;base64' });
    const fileURL = URL.createObjectURL(file);
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file, 'confirmation.pdf');
    } else {
      window.open(fileURL);
    }
  }

  render() {
    const {
      actions: { getPrintConfirmData },
      dispatch,
      printData,
      printConfirm: { isLoading, isLoaded },
    } = this.props;
    return (
      <div className="print-confirm-container">
        <Button
          buttonType="primary"
          className="print-confirm-button"
          type="button"
          loading={isLoading && !isLoaded}
          onClick={() => {
            dispatch(getPrintConfirmData(printData));
          }}
        >
          <img
            alt=""
            src="../../../assets/images/Group.svg"
            className="print-confirm-icon"
          />
          <span> Print Confirmation Details </span>
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { printConfirm } = state;
  return {
    printConfirm,
    printData: getSavedPrintInfo(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getPrintConfirmData: moduleActions.getPrintConfirmData,
    },
    dispatch
  ),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  PrintConfirm
);
